import { AnimationBuilder, AnimationPlayer } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  OauthAEMConfig,
  UserDataService,
  UserSessionService
} from '@com-delta-idp/mnx-oauth';
import {
  ContentBodyAbodeSupportAnalytics,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Subject, Subscription, interval } from 'rxjs';
import { switchMap, takeUntil, takeWhile, tap } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { SessionTimeOutComponent } from '../../common/session-time-out/session-time-out.component';
import { ApplicationConfig } from '../../config/config';
import { ICorporatePartner } from '../../corporate-partner/corporate-partner.interface';
import { FlyoutLoggedinComponent } from '../../flyout/flyout-loggedin/flyout-loggedin.component';
import { AcctactvtyTracker } from '../../model/acctactvty-tracker.model';
import { ContentAuxiliaryNavigation } from '../../model/content/contentauxiliarynavigation.model';
import { ContentLoggedInMilesLabel } from '../../model/content/contentloggedInMilesLabel.model';
import { TodaysTrip } from '../../model/today-trip.model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { LoginServiceWorkerService } from '../../services/login-service-worker.service';
import { TodaysTripAwsService } from '../../services/mydelta-trip-service/trip-aws.service';
import { TripService } from '../../services/mydelta-trip-service/trip.service';
import { TriggerLoginModal } from './login.interface';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ngc-login',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit, OnChanges, OnDestroy {
  public contentLogin: any;
  public contentSignup: any;
  public getLoggedinDtls: any;
  public isLoggedIn = false;
  public isWarmState = false; // CKO persistent login
  public prefCityCode = '';
  public noAvailableMiles = false;
  public changeFocus = false;
  public isMobileAndTabletDevice = false;
  public loginArr: any[] = [];
  public refreshURL = '';
  trackerData: AcctactvtyTracker;
  public businessUser = false;
  auxiliaryArr: ContentAuxiliaryNavigation[];
  milesLabel: ContentLoggedInMilesLabel;
  bsModalRef: BsModalRef;
  accountSummaryServiceSubscribe: Subscription;
  contentHeaderFooterServiceSubscribe: Subscription;
  modalServiceOnHiddenSubscribe: Subscription;
  showSessionTimeOut: Subscription;
  config = {
    animated: false,
    ignoreBackdropClick: true,
    keyboard: false
  };

  public player: AnimationPlayer;
  @Output() prefCity: EventEmitter<string> = new EventEmitter();
  @Output() custId: EventEmitter<any> = new EventEmitter();
  @Output() isCheckInEligible: EventEmitter<any> = new EventEmitter();
  @Input()
  isAlertAdvisory: boolean;

  @Input() isTooltiptoShow: boolean;
  businessAccount = false;
  @Input() corpPartner: ICorporatePartner;
  @Input() displayBusinessTypeSection: boolean;
  @Input() aemErrorMessages: any;
  @Output() isLoggedinFlag: EventEmitter<boolean> = new EventEmitter();
  @Output() edpFlag: EventEmitter<any> = new EventEmitter();
  @Output() crpNamesInfo: EventEmitter<boolean> = new EventEmitter();
  @Output() modalServiceRef = new EventEmitter<any>();
  @Output() skyMilesNbr: EventEmitter<string> = new EventEmitter();
  @Output() medallionStatus: EventEmitter<string> = new EventEmitter();
  @ViewChild('triggerElement') triggerElement: ElementRef;
  @ViewChild('sessionTimeOutComponent')
  sessionTimeOutComponent: SessionTimeOutComponent;

  public stopRefreshSession = true;
  public isReady = false;
  public skymilesNbr: any;
  public resTodayTrip: any;
  public noUpcomingTripContent: any;
  aemErrorMsgDetails: any;
  todayTripServiceTripDetailsSubscribe: Subscription;
  private showSessionRefFlag = true;
  private isTimeout;
  private animationTime = '300ms';
  public login_fromApp: string;
  private unsubscribe: Subject<void> = new Subject();
  private APP_SESS_TIME_OUT: number;
  private APP_NAME = '';
  public showModal = false;
  public triggerLoginModal = false;
  public loginModalOff = false;
  showNewProfileSelector = false;
  isBusiness = false;
  tooltipSignUpContent = '';
  hideLoginSignupTooltip = '';
  hideAccountRecoveryTooltip = '';
  mfaToolTipDisplayPages: string[];
  tooltipLoginContent = '';
  tooltipAccountRecoveryContent: SafeHtml;
  authConfig: OauthAEMConfig;

  isToolTipisHidden = false;
  isAccountRecoveryToolTip = true;
  toolTipTimeout: any;
  displayLoginTooltip$ = new BehaviorSubject<boolean>(false);
  displaySignUpTooltip$ = new BehaviorSubject<boolean>(false);
  displayAccountRecoveryTooltip$ = new BehaviorSubject<boolean>(false);
  tooltipUserIdentifier: string;
  arrowPosition = 'top';
  closeEnable = true;
  constructor(
    private contentService: ContentHeaderFooterService,
    private accountSummaryService: AccountSummaryService,
    private cdf: ChangeDetectorRef,
    private modalService: BsModalService,
    private _config: ApplicationConfig,
    public el: ElementRef,
    private datalayer: DataLayer,
    private _builder: AnimationBuilder,
    private srv: CommonService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private todayTripService: TripService,
    private renderer: Renderer2,
    private cookieHelper: CookieHelper,
    private loginServiceWorker: LoginServiceWorkerService,
    private loggingService: LoggingService,
    private sanitizer: DomSanitizer,
    private userSession: UserSessionService,
    private userData: UserDataService,
    private todaysTripAwsService: TodaysTripAwsService,
    private contentBodyAbodeSupportAnalytics: ContentBodyAbodeSupportAnalytics
  ) {
    this.APP_SESS_TIME_OUT = Number.parseInt(
      this._config.get('APP_SESS_TIME_OUT')
    );
    this.APP_NAME = this._config.get('APP');

    if (
      isPlatformBrowser(this.platformId) &&
      document &&
      document.body &&
      window
    ) {
      try {
        const width = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
        if (width < 992) {
          this.isMobileAndTabletDevice = true;
        } else {
          this.isMobileAndTabletDevice = false;
        }
      } catch (err) {}
    }
  }

  setTrackingObject(selectedItem, e) {
    this.datalayer.setTrackingObjectProp1(
      'header:' + selectedItem.text,
      e.target
    );
  }

  ngOnInit() {
    this.srv.setLoginSessionRefreshVal(this.showSessionRefFlag);
    if (isPlatformBrowser(this.platformId)) {
      this.updateRefreshURL();
      this.login_fromApp = this._config.get('APP_LOGIN_FROM');
      // let pathParts = this.refreshURL.split('/');
      // for (let i = 0; i < pathParts.length; i++) {
      //   if (pathParts[i].match(/home/i)) {
      //     this.refreshURL = window.location.origin;
      //   }
      // }
      this.isTimeout = true;
      this.makeGetDashBrdData();
      this.contentService._isHeaderFooter
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((headerFooterFlag) => {
          if (headerFooterFlag) {
            if (this.contentService.contentHeaderFooter) {
              this.contentHeaderFooterServiceSubscribe =
                this.contentService.contentHeaderFooter
                  .pipe(takeUntil(this.unsubscribe))
                  .subscribe(
                    (data) => {
                      if (data) {
                        this.showNewProfileSelector =
                          !!data?.header?.enableNewProfileSelector;
                        if (this.showNewProfileSelector) {
                          const accountCookie =
                            this.cookieHelper.getCookieValue('account');
                          if (accountCookie && accountCookie.length) {
                            const accountCookieJson = JSON.parse(accountCookie);
                            if (accountCookieJson['isBusiness']) {
                              this.isBusiness = true;
                            }
                          }
                        }
                        const appName = this._config.get('APP');
                        const loginModalSwitchFromAem: TriggerLoginModal[] =
                          data?.header?.triggerLoginModal;
                        this.triggerLoginModal = this.loginModalSwitchValue(
                          loginModalSwitchFromAem,
                          appName
                        );
                        const auxiliaryNavArr = Array.from(
                          data.header.auxiliaryNavigation.values()
                        );
                        for (const item of auxiliaryNavArr) {
                          const key = item['id'];
                          if (
                            key === 'login' ||
                            key === 'signup' ||
                            key === 'accountrecovery'
                          ) {
                            this.loginArr.push(
                              data.header.auxiliaryNavigation.get(key)
                            );
                          }
                        }
                        this.loginArr.forEach((item) => {
                          if (item.id === 'login') {
                            this.tooltipLoginContent = item.details
                              ?.loginTooltipLabel
                              ? item.details.loginTooltipLabel
                              : this.tooltipLoginContent;
                          }
                          if (item.id === 'signup') {
                            this.tooltipSignUpContent = item.details
                              ?.signupTooltipLabel
                              ? item.details.signupTooltipLabel
                              : this.tooltipSignUpContent;
                            this.hideLoginSignupTooltip =
                              item.details?.hideloginSignupTooltip;
                          }
                          if (item.id === 'accountrecovery') {
                            this.tooltipAccountRecoveryContent = item.details
                              ?.accountRecoveryToolTipLabel
                              ? this.accountRecoveryToolTipUtil(
                                  item.details?.accountRecoveryToolTipLabel,
                                  item.details?.accountRecoveryToolTipHeader,
                                  item.details?.accountRecoveryLink,
                                  item.details?.accountRecoveryNavLink
                                )
                              : this.tooltipAccountRecoveryContent;

                            this.hideAccountRecoveryTooltip =
                              item.details?.hideAccountRecoveryTooltip;

                            this.mfaToolTipDisplayPages =
                              item.details?.mfaToolTipDisplayPages;
                          }
                        });
                        if (this.APP_NAME == 'homepage') {
                          if (this.triggerLoginModal === false) {
                            this.loginModalOff = true;
                          }
                          if (
                            this.hideLoginSignupTooltip === 'false' &&
                            this.isTooltiptoShow === true
                          ) {
                            this.showSignUpLoginToolTip();
                          }
                        }

                        this.milesLabel =
                          data.header.auxiliaryNavigation.get(
                            'loggedInMilesLabel'
                          ).details;
                        this.cdf.detectChanges();
                      }
                    },
                    (err) => {}
                  );
            }
          }
        });
    }
  }

  timeOutToolTip() {
    this.toolTipTimeout = setTimeout(() => {
      this.isToolTipisHidden = true;
      this.cdf.detectChanges();
    }, 5000);
  }

  @HostListener('window:scroll', ['$event'])
  hideToolTipOnScroll(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.isMobileAndTabletDevice) {
        this.isToolTipisHidden = true;
        clearTimeout(this.toolTipTimeout);
      }
    }
  }

  accountRecoveryToolTipUtil(
    accountRecoveryToolTipContent: string,
    accountRecoveryToolTipHeader: string,
    accountRecoveryLink: string,
    accountRecoveryNavLink: string
  ): SafeHtml {
    const tooltipHTML = `
      <h4>${accountRecoveryToolTipHeader}</h4>
      <p>${accountRecoveryToolTipContent}</p>
      <a href="${accountRecoveryNavLink}" onclick="event.stopPropagation()">${accountRecoveryLink}</a>
    `;
    return this.sanitizer.bypassSecurityTrustHtml(tooltipHTML);
  }

  showAccountRecoveryPurchaseToolTip() {
    if (
      this.cookieHelper.getCookies(
        `hideAccountRecoveryTooltip_${this.tooltipUserIdentifier}`
      ) === null
    ) {
      this.displayAccountRecoveryTooltip$.next(true);
    }
  }

  closeAccountRecoveryTooltipPopup(input: Event) {
    if ((input.target as HTMLElement).className == 'idp-close-icon') {
      this.cookieHelper.setCookies(
        `hideAccountRecoveryTooltip_${this.tooltipUserIdentifier}`,
        true
      );
      input.stopPropagation();
    }
    this.displayAccountRecoveryTooltip$.next(false);
  }

  closeAccountRecoveryTooltip() {
    this.displayAccountRecoveryTooltip$.next(false);
  }

  showSignUpLoginToolTip() {
    if (sessionStorage.getItem('v27') === 'Y') {
      if (this.cookieHelper.getCookies('hideLoginTooltip') === null) {
        this.displayLoginTooltip$.next(true);
      }
    } else {
      if (this.cookieHelper.getCookies('hideSignUpTooltip') === null) {
        this.displaySignUpTooltip$.next(true);
      }
    }
  }

  closeLoginTooltipPopup(input: any) {
    if (input?.target.className == 'idp-close-icon') {
      this.cookieHelper.setCookies('hideLoginTooltip', true);
    }
    this.displayLoginTooltip$.next(false);
  }

  closeSignUpTooltipPopup(input: any) {
    if (input?.target.className == 'idp-close-icon') {
      this.cookieHelper.setCookies('hideSignUpTooltip', true);
    }
    this.displaySignUpTooltip$.next(false);
  }

  closeSignUpTooltip() {
    this.displaySignUpTooltip$.next(false);
  }

  closeLoginTooltip() {
    this.displayLoginTooltip$.next(false);
  }

  loginModalSwitchValue(
    loginModalSwitchFromAem: TriggerLoginModal[],
    showLoginModalappName: string
  ): boolean {
    let showLoginModal = false;
    if (loginModalSwitchFromAem && loginModalSwitchFromAem.length) {
      loginModalSwitchFromAem.forEach((appSwitch: TriggerLoginModal) => {
        if (appSwitch?.appName === showLoginModalappName && !showLoginModal) {
          showLoginModal = appSwitch?.showLoginModal === 'true' ? true : false;
        }
      });
    }
    return showLoginModal;
  }

  toggleModal() {
    this.showModal = !this.showModal;
    const event = new CustomEvent('login-modal-click', {
      bubbles: true
    });
    document.dispatchEvent(event);
    const body = document.body;
    const loginModalDiv: HTMLElement = document.querySelector('.login-modal');
    const elementTag: HTMLElement = document.querySelector(
      'idp-login-modal-profile-selector'
    );
    if (loginModalDiv && loginModalDiv.classList.contains('d-none')) {
      this.showModal = true;
      this.renderer.addClass(body, 'modal-open');
      elementTag?.setAttribute('shouldCallService', 'true');
      loginModalDiv.classList.remove('d-none');
    } else {
      this.showModal = false;
      elementTag?.setAttribute('shouldCallService', 'false');
      this.renderer.removeClass(body, 'modal-open');
      loginModalDiv?.classList.add('d-none');
    }
    this.cdf.detectChanges();
  }

  ngOnChanges(change: SimpleChanges) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.isMobileAndTabletDevice) {
        this.timeOutToolTip();
      }

      this.listenToEvents();
    }
  }

  listenToEvents() {
    // TODO: needs to refactor code - B-664953
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('service-worker-token', () => this.getLogin());
    }
  }

  async makeGetDashBrdData() {
    const checkForToken = await this.userSession.isTokenAvailable();
    await this.userSession.setTokenDetails();
    if (checkForToken) {
      this.userSession.tokenValue$.next(true);
    } else {
      if (this.userSession.isServiceWorker()) {
        this.accountSummaryServiceSubscribe = this.getAccountSummary();
      }
    }
    this.getLogin();
    await this.userData.getAuthConfigContent().subscribe(async (response) => {
      await this.loginServiceWorker.registerServiceWorker(response);
    });
  }

  getLogin() {
    try {
      if (isPlatformBrowser(this.platformId)) {
        if (this.userSession.getServiceWorkerCheck()) {
          this.accountSummaryServiceSubscribe = this.getAccountSummary();
        }
      }
    } catch (e) {}
  }

  getAccountSummary() {
    return this.userData
      .getAuthConfigContent()
      .pipe(
        switchMap((authConfig: OauthAEMConfig) =>
          this.accountSummaryService.getAccountSummaryDetails().pipe(
            tap((response) => {
              if (
                response &&
                this.validateToolTipDisplay(
                  response.loggedIn as boolean,
                  authConfig
                )
              ) {
                this.tooltipUserIdentifier = response.smNumber;
                this.showAccountRecoveryPurchaseToolTip();
              }
              this.authConfig = authConfig;
            })
          )
        )
      )
      .subscribe(
        (res) => {
          // res = this.accountSummaryService.getDummyLogin();
          this.isReady = true;
          if (res !== null) {
            this.isWarmState = res.isWarmState ? res.isWarmState : false; // CKO persistent login
            if (res.loggedIn === true || this.isWarmState === true) {
              /*Added for datalayer changes starts */
              this.datalayer.customerInfo = res;
              const skymilesNbr = res.smNumber;
              this.skyMilesNbr.emit(skymilesNbr);
              this.medallionStatus.emit(res.membershipLevel);
              if (res.loggedIn === true) {
                // CKO Persistent login
                this.isLoggedIn = true;
                if (this.isTimeout === true) {
                  this.loginTimeout();
                }
              } else {
                this.isLoggedIn = false;
              }
              this.isLoggedinFlag.emit(this.isLoggedIn);
              this.getLoggedinDtls = res;
              this.crpNamesInfo.emit(res);
              this.noAvailableMiles =
                this.getLoggedinDtls.smBalance > 0 ? false : true;
              const respObj = {
                flag: res.crprtAgrmntFound,
                isWarmState: this.isWarmState
              };
              this.edpFlag.emit(respObj);
              // Logic to identify userType & company selected & companiesList
              if (res.crprtAgrmntTypeCode) {
                this.businessUser = res.crprtAgrmntFound;
              } else {
                this.businessUser = false;
              }
              if (res.usrProvdPrefHomeArptCd) {
                this.prefCityCode =
                  res.usrProvdPrefHomeArptCd.length === 3
                    ? res.usrProvdPrefHomeArptCd
                    : '';
                this.prefCity.emit(this.prefCityCode);
              } else if (res.sysDrvdPrefHomeArptCd) {
                this.prefCityCode =
                  res.sysDrvdPrefHomeArptCd.length === 3
                    ? res.sysDrvdPrefHomeArptCd
                    : '';
                this.prefCity.emit(this.prefCityCode);
              }
              if (res.customerID !== null) {
                this.custId.emit(res.customerID);
              }
            } else {
              this.isLoggedIn = false;
              this.custId.emit('');
              this.isCheckInEligible.emit(false);
            }
            if (
              this.isLoggedIn &&
              res.smNumber !== undefined &&
              res.smNumber !== null
            ) {
              this.skymilesNbr = res.smNumber;
              this.todayTripServiceTripDetailsSubscribe = this.authConfig
                .TRIPS_API_AWS
                ? this.todaysTripAwsService
                    .getTodayTrip(this.skymilesNbr)
                    .pipe(takeUntil(this.unsubscribe))
                    .subscribe(
                      (data) => this.processTodaysTripData(data),
                      (err) => {
                        this.loggingService.log('Caught Error: ' + err);
                      }
                    )
                : this.todayTripService
                    .getTripDetailsDetails(this.skymilesNbr)
                    .pipe(takeUntil(this.unsubscribe))
                    .subscribe(
                      (data) => this.processTodaysTripData(data),
                      (err) => {
                        this.loggingService.log('Caught Error: ' + err);
                      }
                    );
            }
          } else {
            this.isLoggedIn = false;
            this.custId.emit('');
            this.isCheckInEligible.emit(false);
          }
        },
        (err) => {
          this.isReady = true;
          this.loggingService.log('Caught Error: ' + err);
          this.custId.emit('');
          this.isCheckInEligible.emit(false);
        }
      );
  }

  processTodaysTripData = (data: TodaysTrip) => {
    if (data.errors?.length === 0) {
      this.resTodayTrip = data.trip;
      if (this.resTodayTrip == null) {
        this.aemErrorMsgDetails = this.aemErrorMessages
          ? this.aemErrorMessages.get('NO_TRIPS_AVAIL')
          : 'NO_TRIPS_AVAIL';
        if (this.aemErrorMsgDetails) {
          this.changeFocus = true;
        }
      } else {
        if (this.resTodayTrip?.checkinEligible) {
          this.isCheckInEligible.emit(this.resTodayTrip.checkinEligible);
        }
      }
    }
  };

  onSubmitLogin(form: NgForm) {}

  openLoggedInFlyout(event) {
    if (event.which === 13 || event.keyCode === 13) {
      this.open(event);
    }
  }

  open(e) {
    const bodyScroll = document.documentElement.scrollTop;
    e.preventDefault();
    let obj;
    if (this.isAlertAdvisory) {
      obj = Object.assign({}, this.config, {
        class:
          'loggedIn-modal-dialog loggedIn-alertAdv-modal-dialog no-transform'
      });
    } else {
      obj = Object.assign({}, this.config, {
        class: 'loggedIn-modal-dialog no-transform'
      });
    }
    this.bsModalRef = this.modalService.show(FlyoutLoggedinComponent, obj);
    if (this.bsModalRef && isPlatformBrowser(this.platformId)) {
      // this.bsModalRef.content._el.nativeElement.focus();
      const loginModal =
        this.bsModalRef.content._el.nativeElement.querySelector(
          '.content-loggedIn'
        );
      loginModal.focus();
      if (document.body.scrollWidth > 992) {
        this.bsModalRef.content.loggedInModalLoaded = true;
        document
          .getElementsByTagName('modal-container')[0]
          .classList.add('notification-loggedin-modal');
        this.modalServiceRef.emit(this.bsModalRef);
      } else {
        this.bsModalRef.content.isFlyoutLoaded = true;
        document
          .getElementsByClassName('feed-header')[0]
          .classList.add('feed-header-fixed');
      }
      // this.bsModalRef.content.focusActiveTab();
      this.bsModalRef.content.setModalHeight();
      const flyToggle = this.el.nativeElement.querySelector('.open-flyout');
      if (flyToggle !== null && flyToggle !== undefined) {
        flyToggle.className = 'open-flyout icon-advsearchtriangle toggle-up';
      }
    }
    const htmlRoot = document.getElementsByTagName('html')[0];
    if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
      htmlRoot.className += ' no-scroll';
    }
    this.modalServiceOnHiddenSubscribe = this.modalService.onHidden
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (reason: string) => {
          this.isTimeout = false;
          this.getLogin();
          const toggleFlyout =
            this.triggerElement.nativeElement.querySelector('.open-flyout');
          if (toggleFlyout !== undefined && toggleFlyout !== null) {
            toggleFlyout.className = 'open-flyout icon-advsearchtriangle';
          }
          /* if (this.changeFocus) {
          let bookTripLink = <HTMLElement>document.querySelector('#headerLinksContainer ul.nav-primary li a.nav-link-book');
          let bookWidget = bookTripLink.parentElement.classList.contains('active-menu');
          if (bookWidget) {
            const bookWidgetFrom = <HTMLElement>document.querySelector('#fromAirportName');
            const bookWidgetFromInput = <HTMLInputElement>document.querySelector('#fromAirportName input[name=fromAirportCode]');
            let bookWidgetFromInputVal = '';
            if (bookWidgetFromInput !== null) {
              bookWidgetFromInputVal = bookWidgetFromInput.value;
            }
            const bookWidgetTo = <HTMLElement>document.querySelector('#toAirportName');
            const bookWidgetToInput = <HTMLInputElement>document.querySelector('#toAirportName input[name=arrivalCity]');
            let bookWidgetToInputVal = '';
            if (bookWidgetToInput !== null) {
              bookWidgetToInputVal = bookWidgetToInput.value;
            }
            if (bookWidgetFromInputVal !== '' && bookWidgetToInputVal !== '') {
              if (this.isMobileAndTabletDevice) {
                bookTripLink.dispatchEvent(new Event('focus'));
              } else {
                bookTripLink.focus();
              }
            } else if (bookWidgetFromInputVal !== '') {
              if (this.isMobileAndTabletDevice) {
                bookWidgetTo.dispatchEvent(new Event('focus'));
              } else {
                bookWidgetTo.focus();
              }
            } else {
              if (this.isMobileAndTabletDevice) {
                bookWidgetFrom.dispatchEvent(new Event('focus'));
              } else {
                bookWidgetFrom.focus();
              }
            }
          } else {
            const myTripWidgetConfInput = <HTMLInputElement>document.querySelector('.mytrips-widget-container input#confirmationNo');
            if (myTripWidgetConfInput !== null && myTripWidgetConfInput !== undefined) {
              if (this.isMobileAndTabletDevice) {
                myTripWidgetConfInput.dispatchEvent(new Event('focus'));
              } else {
                myTripWidgetConfInput.focus();
              }
            }
          }
        } else */
          this.triggerElement.nativeElement.focus();

          this.modalServiceRef.emit(null);
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    this.srv.dragModalContainers(this.el, this.renderer);
    document.documentElement.scrollTop = bodyScroll;
    this.srv.focusModalContainers(this.el, this.renderer);
  }

  disableBusinessPage(isBusinessLoginDisabled) {
    this.businessAccount = !isBusinessLoginDisabled;
    this.businessUser = !isBusinessLoginDisabled;
  }

  getClassName(flag) {
    const classList = {
      GM: {
        'pax-miles': true,
        'pax-miles-gm': true
      },
      DM: {
        'pax-miles': true,
        'pax-miles-dm': true
      },
      PM: {
        'pax-miles': true,
        'pax-miles-pm': true
      },
      FF: {
        'pax-miles': true,
        'pax-miles-ff': true
      },
      FO: {
        'pax-miles': true,
        'pax-miles-sm': true
      }
    };
    const bgClassNames = classList[flag] ?? {
      'pax-miles': true,
      'pax-miles-mem': true
    };
    return bgClassNames;
  }

  getLabelName() {
    let labelName = '';
    if (this.milesLabel) {
      labelName =
        this.corpPartner.showBusinessMilesLabel || this.isBusiness
          ? this.milesLabel.loggedInMilesLabelBusiness
          : this.milesLabel.loggedInMilesLabel;
    }
    return labelName;
  }

  public loginTimeout() {
    if (this.APP_SESS_TIME_OUT) {
      const bodyScroll = document.documentElement.scrollTop;
      this.showSessionTimeOut = interval(this.APP_SESS_TIME_OUT)
        .pipe(takeWhile(() => this.srv.getLoginSessionRefreshVal() === true))
        .subscribe((i) => {
          if (this.APP_NAME !== 'checkout') {
            const obj = Object.assign({}, this.config, {
              class: 'session-time-out no-transform'
            });
            this.bsModalRef = this.modalService.show(
              SessionTimeOutComponent,
              obj
            );
            this.srv.dragModalContainers(this.el, this.renderer);
            this.srv.removeMultipleContainers(this.el);
            document.documentElement.scrollTop = bodyScroll;
            this.srv.focusModalContainers(this.el, this.renderer);
            this.isTimeout = false;
            this.getLogin();
            this.stopRefreshSession = true;
            this.showSessionRefFlag = false;
            this.srv.setLoginSessionRefreshVal(this.showSessionRefFlag);
          }
        });
    }
  }

  updateRefreshURL() {
    let searchParam = window.location.search;
    const aemrefreshurl = <HTMLInputElement>(
      document.querySelector('#aemrefreshurl')
    );
    if (window.location.pathname.indexOf('/home') > -1) {
      this.refreshURL = window.location.origin;
    } else if (
      window.location.pathname.lastIndexOf('/') ===
        window.location.pathname.length - 1 ||
      (aemrefreshurl !== null && aemrefreshurl !== undefined)
    ) {
      if (aemrefreshurl !== null && aemrefreshurl !== undefined) {
        if (searchParam === '') {
          searchParam = '?staticurl=t';
        } else {
          searchParam = searchParam + '&staticurl=t';
        }
        this.refreshURL = this._config.onBrowser
          ? window.location.pathname + searchParam
          : '';
      } else {
        this.refreshURL = this._config.onBrowser
          ? window.location.pathname.substring(
              0,
              window.location.pathname.length - 1
            ) + window.location.search
          : '';
      }
    } else {
      this.refreshURL = window.location.href;
    }
  }

  ngOnDestroy() {
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.modalServiceOnHiddenSubscribe) {
      this.modalServiceOnHiddenSubscribe.unsubscribe();
    }
    if (this.showSessionTimeOut) {
      this.showSessionTimeOut.unsubscribe();
    }
    if (this.todayTripServiceTripDetailsSubscribe) {
      this.todayTripServiceTripDetailsSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.modalServiceRef.emit(null);
    this.cdf.detach();
  }

  private validateToolTipDisplay(
    loggedIn: boolean,
    authConfig: OauthAEMConfig
  ): boolean {
    return (
      loggedIn &&
      this.mfaToolTipDisplayPages?.some((page) =>
        window.location.pathname.includes(page)
      ) &&
      this.hideAccountRecoveryTooltip === 'false' &&
      authConfig.MFA_FLOW
    );
  }
}
